import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const gameVuex = createNamespacedHelpers("game");
export default {
  name: "mLoading",
  computed: {},
  data() {
    return {
      backgroundImage: "",
      imgUrlArr: [require('@images/leaders-head.png'), require('@images/firend-head.jpg'), require('@images/yes-img.png'), require('@images/no-img.png'), require('@images/pop-earn-ticket-img.png'), require('@images/m1.jpg'), require('@images/m2.jpg'), require('@images/m3.jpg'), require('@images/task-head.jpg'), require("@images/buySpineItemBg1.png"), require("@images/buySpineItemBg2.png"), require("@images/buySpineItemBg3.png"), require("@images/buySpineItemBg2-tag.png"), require("@images/buySpineItemBg3-tag.png")]
    };
  },
  watch: {},
  methods: {
    unorderedPreload() {
      this.$nextTick(() => {
        try {
          let backgroundImages = [];
          // 无序加载，并发下载图片
          console.log("this.imgUrlArr", this.imgUrlArr);
          this.imgUrlArr.forEach((imgUrl, i) => {
            var oImg = new Image();
            oImg.addEventListener("load", this.imgLoaded);
            oImg.addEventListener("error", this.imgLoaded);
            oImg.src = imgUrl;
            backgroundImages.push(`url(${imgUrl})`);
          });
          this.backgroundImage = backgroundImages.join(",");
        } catch (err) {}
      });
    }
  },
  mounted() {
    this.unorderedPreload();
  }
};